module.exports = __webpack_public_path__ + "static/media/TRIAL 2 if-both-wrong.785953e4.mp3";